import { useTranslation } from 'next-i18next';
import styles from '@components/Checkbox/Checkbox.styles';
import { TProps } from '@components/Checkbox/typescript';
import Icon from '@components/icons/Icon';
import Check from '@components/icons/components/Check';
const Checkbox = ({
  value,
  onChange = () => undefined,
  children,
  addSx = {},
  name = '',
  showError = false,
  error = '',
  readonly = false,
  disabled = false,
  cy
}: TProps) => {
  const {
    t
  } = useTranslation('common');
  const onClick = () => {
    if (readonly || disabled) return;
    if (onChange) onChange(!value);
  };
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };
  const testId = cy || 'checkbox';
  return <div sx={styles.checkboxWrapper} data-testid={`${testId}-wrapper`}>
      <div className="checkbox-container" sx={{
      ...styles.checkboxContainer,
      ...addSx
    }} onClick={onClick} onKeyDown={onKeyDown} role="checkbox" aria-checked={value} tabIndex={disabled ? -1 : 0} data-testid={`${testId}-container`}>
        <input type="checkbox" sx={styles.hiddenCheckbox} name={name} checked={value} readOnly data-testid={`${testId}-input`} />
        <span className="checkbox-checkmark" sx={styles.checkMarkContainer(value, showError, disabled)} data-testid={`${testId}-checkmark`}>
          <Icon color="neutralWhite" addSx={styles.checkMarkIcon(value, readonly, disabled)} cy={`${testId}-icon`}>
            <Check />
          </Icon>
        </span>
        <label className="checkbox-label" htmlFor={name} sx={styles.checkboxLabel} data-testid={`${testId}-label`}>
          {children}
        </label>
      </div>
      <div className="checkbox-error" sx={styles.error(showError && error.length > 0)} data-testid={`${testId}-error`}>
        {showError && t(`${error}`)}
      </div>
    </div>;
};
export default Checkbox;